import React from 'react';
import { TRACE_STORE_NAME } from '@/creditflowresearch/application/Trace/constants';
import { getFiltersByKeysWithValues } from '@framework/ui/Organisms/Filters/helpers';
import FiltersBtn from '@/creditflowresearch/ui/common/components/organisms/FiltersBtn/FiltersBtn';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import { useTraceFiltersContext } from '@/creditflowresearch/application/Trace/TraceFilters/TraceFiltersContext';

const filtersKeys = [
  'tradeTime',
  'includedSubsectorIds',
  'includedIssuerIds',
  'size',
  'price',
  'coupon',
  'maturityDate',
  'includedContraPartyTypes',
  'includedRemunerations',
  'includedReportingPartyTypes',
  'includedReportingPartySides',
  'includedTradeStatuses',
  'tradeDate',
];

interface IProps {
  className: string,
  onClick: () => void,
}

const FilterButtonContainer = (props: IProps) => {
  const { getFilters } = useFiltersContext();
  const filtersState = getFilters(TRACE_STORE_NAME);
  const { dateFromMin } = useTraceFiltersContext();
  const filtersCount = Object.keys(getFiltersByKeysWithValues({ filtersState, filtersKeys, dateFromMin })).length;
  return <FiltersBtn { ...props } filtersCount={ filtersCount } />;
};

export default FilterButtonContainer;
